module.exports = __webpack_public_path__ + "r-v3/img/device-mic-mini_off.6c233fd1.svg";